const HackerRankIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="50" fill="#2EC866" />
    <text x="50%" y="50%" fill="white" font-size="35" text-anchor="middle" dy=".35em" font-family="Arial, sans-serif">H</text>
  </svg>
);

export default HackerRankIcon;
